import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import QRCodeGenerator from "../QRCodeAdminPage/OrganizationManagement/Component/Qrgenerator";
import OrganizationService from "../Services/QRCodeServices/OrganizationManagement/OrganizationService";

const ProfileDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = user?.organizationInfo?.id || ""; // Null if user or organizationInfo is not available

  const [data, setData] = useState([]);
  const orgCode = user?.organizationInfo?.orgCode || data?.orgCode; // If orgCode exists, use it; otherwise, use id

  const fetchDetail = async () => {
    try {
      const response = await OrganizationService.detail(orgId);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  console.log(data)

  const url = `${window.location.origin}/${orgCode}?source=qr-menu`;

  return (
    <React.Fragment>
      <Row className="d-print-none">
        <Col xs={12} md={6} lg={4}>
          <QRCodeGenerator url={url} data={data} />
        </Col>
        <Col xs={12} md={6} lg={8}>
          <Row>
            <Col md={6} className="mb-2">
              <h5 className="fw-bold">Organization Name: </h5>
              <h6 className="fw-normal">{data?.name}</h6>
            </Col>
            <Col md={6} className="mb-2">
              <h5 className="fw-bold">Organization Email:</h5>
              <h6 className="fw-normal">{data?.email}</h6>
            </Col>
            <Col md={6} className="mb-2">
              <h5 className="fw-bold">Contact Number:</h5>
              <h6 className="fw-normal">{data?.tel}</h6>
            </Col>
            <Col md={6} className="mb-2">
              <h5 className="fw-bold">Address 1:</h5>
              <h6 className="fw-normal">{data?.address1}</h6>
            </Col>
            {data?.address2 && (
              <Col md={6} className="mb-2">
                <h5 className="fw-bold">Address 2:</h5>
                <h6 className="fw-normal">{data?.address2}</h6>
              </Col>
            )}
            {data?.website && (
              <Col md={6} className="mb-2">
                <h5 className="fw-bold">Website:</h5>
                <h6 className="fw-normal">{data?.website}</h6>
              </Col>
            )}
            <hr style={{ width: '98%', marginLeft: 'auto', marginRight: 'auto' }} />
            <Col md={12}>
              <h5 className="fw-bold">Tag Line</h5>
              <p>{data?.tagLine}</p>
            </Col>
            <hr style={{ width: '98%', marginLeft: 'auto', marginRight: 'auto' }} />
            <Col md={12}>
              <h5 className="fw-bold">About Us</h5>
              {/* <p>{data?.aboutUs}</p> */}
              <p dangerouslySetInnerHTML={{ __html: data?.aboutUs?.replace(/\r\n|\r|\n/g, "<br/>") }} />

            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ProfileDashboard;

// import React, { useEffect, useState } from "react";
// import { Card, Col, Row } from "reactstrap";
// import CountUp from "react-countup";
// import QRCodeGenerator from "../QRCodeAdminPage/OrganizationManagement/Component/Qrgenerator";
// import OrganizationService from "../Services/QRCodeServices/OrganizationManagement/OrganizationService";

// const ProfileDashboard = () => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   const orgId = user?.organizationInfo?.id || "";
//   const [data, setData] = useState([]);
//   const orgCode = user?.organizationInfo?.orgCode || data?.orgCode;

//   const fetchDetail = async () => {
//     try {
//       const response = await OrganizationService.detail(orgId);
//       setData(response);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     fetchDetail();
//   }, []);

//   const url = `${window.location.origin}/${orgCode}?source=qr-menu`;

//   return (
//     <React.Fragment>
//       <Row className="d-print-none">
//         <Col xs={12} md={6} lg={4}>
//           <QRCodeGenerator url={url} data={data} />
//         </Col>
//         <Col xs={12} md={6} lg={8}>
//           <Row>
//             <Col md={6} className="mb-2">
//               <h5 className="fw-bold">Organization Name: </h5>
//               <h6 className="fw-normal">{data?.name}</h6>
//             </Col>
//             <Col md={6} className="mb-2">
//               <h5 className="fw-bold">Organization Email:</h5>
//               <h6 className="fw-normal">{data?.email}</h6>
//             </Col>
//             <Col md={6} className="mb-2">
//               <h5 className="fw-bold">Contact Number:</h5>
//               <h6 className="fw-normal">{data?.tel}</h6>
//             </Col>
//             <Col md={6} className="mb-2">
//               <h5 className="fw-bold">Address 1:</h5>
//               <h6 className="fw-normal">{data?.address1}</h6>
//             </Col>
//             {data?.address2 && (
//               <Col md={6} className="mb-2">
//                 <h5 className="fw-bold">Address 2:</h5>
//                 <h6 className="fw-normal">{data?.address2}</h6>
//               </Col>
//             )}
//             {data?.website && (
//               <Col md={6} className="mb-2">
//                 <h5 className="fw-bold">Website:</h5>
//                 <h6 className="fw-normal">{data?.website}</h6>
//               </Col>
//             )}
//             <hr
//               style={{ width: "98%", marginLeft: "auto", marginRight: "auto" }}
//             />
//             <Col md={12}>
//               <h5 className="fw-bold">Tag Line</h5>
//               <p>{data?.tagLine}</p>
//             </Col>
//             <hr
//               style={{ width: "98%", marginLeft: "auto", marginRight: "auto" }}
//             />
//             <Col md={12}>
//               <h5 className="fw-bold">About Us</h5>
//               <p>{data?.aboutUs}</p>
//             </Col>
//           </Row>
//         </Col>
//       </Row>
//       <Row className="mt-4">
//         <Col lg={4}>
//           <Card
//             className="p-3 rounded-3 mb-2"
//             style={{
//               backgroundColor: "rgba(0, 123, 255, 0.1)",
//               borderColor: "rgba(0, 123, 255, 0.3)",
//             }}
//           >
//             <span className="fs-6 fw-semibold text-muted text-uppercase">
//               Total Sales
//             </span>
//             <div>
//               <p className="fs-6 fw-semibold mb-2">
//                 Amount: Rs.
//                 <CountUp
//                   start={0}
//                   end={25000}
//                   duration={2}
//                   separator=","
//                   decimals={2}
//                   prefix=" "
//                 />
//               </p>
//             </div>
//           </Card>
//         </Col>
//         <Col lg={4}>
//           <Card
//             className="p-3 rounded-3 mb-2"
//             style={{
//               backgroundColor: "rgba(40, 167, 69, 0.1)",
//               borderColor: "rgba(40, 167, 69, 0.3)",
//             }}
//           >
//             <span className="fs-6 fw-semibold text-muted text-uppercase">
//               Kitchen Order Tickets
//             </span>
//             <div>
//               <p className="fs-6 fw-semibold mb-2">
//                 Count:
//                 <CountUp start={0} end={120} duration={2} />
//               </p>
//             </div>
//           </Card>
//         </Col>
//         <Col lg={4}>
//           <Card
//             className="p-3 rounded-3 mb-2"
//             style={{
//               backgroundColor: "rgba(255, 193, 7, 0.1)",
//               borderColor: "rgba(255, 193, 7, 0.3)",
//             }}
//           >
//             <span className="fs-6 fw-semibold text-muted text-uppercase">
//               Bar Order Tickets
//             </span>
//             <div>
//               <p className="fs-6 fw-semibold mb-2">
//                 Count:
//                 <CountUp start={0} end={80} duration={2} />
//               </p>
//             </div>
//           </Card>
//         </Col>
//       </Row>
//     </React.Fragment>
//   );
// };

// export default ProfileDashboard;
